export default __webpack_public_path__ + "static/media/Staff4.68c744c3.JPG";